import { ReactNode } from 'react';
import { Heading4 } from '../../shared/Typography';
import { StyledSkillsContainer, StyledSkillsList } from './SkillsList.styled';

type SkillsList = {
  skillsListTitle: string;
  children?: ReactNode;
  variant?: string;
};

const SkillsList = ({ skillsListTitle, children, variant }: SkillsList) => (
  <StyledSkillsContainer>
    <Heading4>{skillsListTitle}</Heading4>
    <StyledSkillsList variant={variant}>{children}</StyledSkillsList>
  </StyledSkillsContainer>
);

export default SkillsList;
